export const FindAHealthCenterRadius = [
  {
    value: '5',
    displayText: '5 miles'
  },
  {
    value: '10',
    displayText: '10 miles'
  },
  {
    value: '20',
    displayText: '20 miles'
  },
  {
    value: '30',
    displayText: '30 miles'
  },
  {
    value: '40',
    displayText: '40 miles'
  },
  {
    value: '50',
    displayText: '50 miles'
  },
  {
    value: '75',
    displayText: '75 miles'
  },
  {
    value: '100',
    displayText: '100 miles'
  },
  {
    value: '250',
    displayText: '250 miles'
  }
];

export const HdsLocatorRadius = [
  {
    value: '50',
    displayText: '50 miles'
  },
  {
    value: '100',
    displayText: '100 miles'
  },
  {
    value: '150',
    displayText: '150 miles'
  },
  {
    value: '200',
    displayText: '200 miles'
  },
  {
    value: '250',
    displayText: '250 miles'
  },
  {
    value: '300',
    displayText: '300 miles'
  },
  {
    value: '350',
    displayText: '350 miles'
  },
  {
    value: '400',
    displayText: '400 miles'
  },
  {
    value: '450',
    displayText: '450 miles'
  },
  {
    value: '5000',
    displayText: '5000 miles'
  }
];

export const OrganTransplantCenterRadius = [
  {
    value: '50',
    displayText: '50 miles'
  },
  {
    value: '100',
    displayText: '100 miles'
  },
  {
    value: '150',
    displayText: '150 miles'
  },
  {
    value: '200',
    displayText: '200 miles'
  },
  {
    value: '250',
    displayText: '250 miles'
  },
  {
    value: '300',
    displayText: '300 miles'
  },
  {
    value: '350',
    displayText: '350 miles'
  },
  {
    value: '400',
    displayText: '400 miles'
  },
  {
    value: '450',
    displayText: '450 miles'
  },
  {
    value: '5000',
    displayText: '5000 miles'
  }
];

export const HIVMedicalProviderRadius = [
  {
    value: '10',
    displayText: '10 miles'
  },
  {
    value: '20',
    displayText: '20 miles'
  },
  {
    value: '30',
    displayText: '30 miles'
  },
  {
    value: '40',
    displayText: '40 miles'
  },
  {
    value: '50',
    displayText: '50 miles'
  },
  {
    value: '60',
    displayText: '60 miles'
  },
  {
    value: '70',
    displayText: '70 miles'
  },
  {
    value: '80',
    displayText: '80 miles'
  },
  {
    value: '90',
    displayText: '90 miles'
  },
  {
    value: '100',
    displayText: '100 miles'
  }
];

export const FindANetworkRadius = [
  {
    value: '50',
    displayText: '50 miles'
  },
  {
    value: '150',
    displayText: '150 miles'
  },
  {
    value: '250',
    displayText: '250 miles'
  },
  {
    value: '350',
    displayText: '350 miles'
  },
  {
    value: '450',
    displayText: '450 miles'
  },
  {
    value: '550',
    displayText: '550 miles'
  },
  {
    value: '650',
    displayText: '650 miles'
  },
  {
    value: '750',
    displayText: '750 miles'
  },
  {
    value: '850',
    displayText: '850 miles'
  },
  {
    value: '5000',
    displayText: '5000 miles'
  }
];
